"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class AlertClient extends authenticated_client_1.AuthenticatedClient {
    getAll(projectId, order) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${projectId}/users/me/alerts`;
            if (order) {
                url += url.includes('?') ? `&order=${order}` : `?order=${order}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getAllWithShared(projectId, order) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${projectId}/users/me/alerts-with-shared`;
            if (order) {
                url += url.includes('?') ? `&order=${order}` : `?order=${order}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getCount(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts?fields=id`);
            return response.payload && response.payload.length;
        });
    }
    getUnseenCount(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts/unseen`);
            return response.payload;
        });
    }
    get(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/alerts/${id}`);
            return response.payload;
        });
    }
    create(projectId, alert) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/alerts`, alert);
            return response.payload;
        });
    }
    update(projectId, id, alert) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/${id}`, alert);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/projects/${projectId}/users/me/alerts/${id}`);
        });
    }
    setSeen(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/seen`);
        });
    }
    share(projectId, id, alertShared) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/alerts/${id}/share`, alertShared);
            return response.payload || [];
        });
    }
    dismissShare(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/alerts/${id}/dismiss-share`);
        });
    }
    findById(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${projectId}/users/me/notifications/${id}`;
            if (fields) {
                url = `${url}?${this.getQueryString({
                    fields,
                })}`;
            }
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getNotifications(projectId, searchRequestModel = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/notifications?${this.getQueryString(searchRequestModel)}`);
            return response.payload || [];
        });
    }
    deleteAllNotifications(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/projects/${projectId}/users/me/notifications`);
        });
    }
    deleteNotification(projectId, notificationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/projects/${projectId}/users/me/notifications/${notificationId}`);
        });
    }
    addNotificationFeedback(projectId, notificationId, feedback) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/notifications/${notificationId}/feedback`, feedback);
            return response.payload;
        });
    }
    getUnseenNotificationsCount(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/notifications/count?filter={"isNew": "true"}`);
            return response.payload;
        });
    }
    setNotificationsSeen(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/projects/${projectId}/users/me/notifications/seen`);
        });
    }
    getQueryString(params) {
        return Object.entries(params)
            .filter((e) => e[1] !== undefined && e[1] !== null)
            .reduce((query, e) => query + `${e[0]}=${this.encodeValue(e[1])}&`, '');
    }
}
exports.AlertClient = AlertClient;
//# sourceMappingURL=alert.client.js.map